import { useRef } from 'react';

import { EditMilestonesModal } from './modal/edit-milestones-modal';
import {
  EditPayrunMilestonesProps,
  ModalDialogRef,
} from './edit-payrun-milestones.types';
import { EditPayrunMilestonesButton } from './edit-payrun-milestones-button';

export function EditPayrunMilestones({
  renderButton,
  payrunId,
}: EditPayrunMilestonesProps) {
  const modalRef = useRef<ModalDialogRef>(null);

  const handleOpenModal = () => {
    modalRef.current?.openModalDialog();
  };

  if (!payrunId) return null;

  return (
    <>
      <EditPayrunMilestonesButton onClick={handleOpenModal} renderButton={renderButton} />

      <EditMilestonesModal ref={modalRef} payrunId={payrunId} />
    </>
  );
}

export default EditPayrunMilestones;
